import Link from 'next/link';
import styled from 'styled-components';
import { colors } from 'constants/theme';
export const Container = styled.header.withConfig({
  displayName: "headercss__Container",
  componentId: "sc-1htsvgv-0"
})(["display:flex;justify-content:space-between;align-items:center;padding:2rem 4rem;a{color:", ";transition:color 0.2s ease;text-decoration:none;&:hover{color:inherit;}}"], colors.grey);
export const LogoLink = styled(Link).withConfig({
  displayName: "headercss__LogoLink",
  componentId: "sc-1htsvgv-1"
})(["display:inline-block;position:relative;"]);